import React, { useEffect } from 'react'
import { TextField, Typography } from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CancelIcon from '@material-ui/icons/Cancel'

const passwordRules: { [key: string]: (password: string) => boolean } = {
  length: (password: string) => password.length >= 8,
  uppercase: (password: string) => /[A-Z]/.test(password),
  lowercase: (password: string) => /[a-z]/.test(password),
  number: (password: string) => /[0-9]/.test(password),
  symbol: (password: string) => /[^A-Za-z0-9]/.test(password),
}

const ruleLabels: { [key: string]: string } = {
  length: '8 characters',
  uppercase: 'uppercase letter',
  lowercase: 'lowercase letter',
  number: 'number',
  symbol: 'symbol',
}

type PasswordInputWithRulesProps = {
  password: string
  onChange: (value: string) => void
  passwordValidity: {
    length: boolean
    uppercase: boolean
    lowercase: boolean
    number: boolean
    symbol: boolean
  }
  setPasswordValidity: (validity: PasswordInputWithRulesProps['passwordValidity']) => void
}

export const PasswordInputWithRules = ({
  password,
  onChange,
  passwordValidity,
  setPasswordValidity,
}: PasswordInputWithRulesProps) => {
  useEffect(() => {
    if (password) {
      setPasswordValidity({
        length: passwordRules.length(password),
        uppercase: passwordRules.uppercase(password),
        lowercase: passwordRules.lowercase(password),
        number: passwordRules.number(password),
        symbol: passwordRules.symbol(password),
      })
    }
  }, [password, setPasswordValidity])

  return (
    <div>
      <TextField
        fullWidth
        label="Password"
        type="password"
        value={password}
        onChange={(e) => onChange(e.target.value)}
        margin="normal"
      />

      {password && (
        <div style={{ marginTop: '8px' }}>
          {Object.entries(ruleLabels).map(([key, label]) => (
            <Typography
              key={key}
              style={{
                fontSize: '12px',
                color: passwordValidity[key as keyof typeof passwordValidity] ? 'green' : 'red',
              }}
            >
              {passwordValidity[key as keyof typeof passwordValidity] ? (
                <CheckCircleIcon style={{ color: 'green', fontSize: 16, marginRight: 4 }} />
              ) : (
                <CancelIcon style={{ color: 'red', fontSize: 16, marginRight: 4 }} />
              )}
              {label}
            </Typography>
          ))}
        </div>
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Employees/BiotrackUser/PasswordInputWithRules.tsx